import Main from "./components/Main";
import {Box} from "@chakra-ui/react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import {dialog} from "./constants";
import React from "react";

function App() {
    return(
        <Box>
            <Header/>
            <Main/>
            <dialog.Viewport/>
            <Footer/>
        </Box>

    )
}

export default App;